import { hookstate } from "@hookstate/core";

export type FilterState = {
  language?: string;
};

export const languagesFilterStore = hookstate<FilterState>({});
